<form class="password-form" [formGroup]="formGroup" (submit)="submit()">
  <div class="text-white text-xl mt-4">
    {{title}}
  </div>
  <div class="my-4 text-hint text-lg leading-relaxed">
    {{subtitle}}
  </div>
  <ng-container *ngIf="formGroup?.controls?.currentPassword">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Current Password</mat-label>
      <input
        matInput
        formControlName="currentPassword"
        placeholder="Current password"
        name="currentPassword"
        type="password"
        />
      <mat-error
        *ngIf="formGroup?.controls?.currentPassword.hasError('required')">
        {{passwordValidator.errorMessage.required}}
      </mat-error>
      <mat-error
        *ngIf="formGroup?.controls?.currentPassword.hasError('minlength')">
        {{passwordValidator.errorMessage.minLength}}
      </mat-error>
      <mat-error
        *ngIf="formGroup?.controls?.currentPassword.hasError('pattern')">
        {{passwordValidator.errorMessage.pattern}}
      </mat-error>
    </mat-form-field>
    <div class="py-2"></div>
  </ng-container>
  <mat-form-field class="w-100" appearance="outline">
    <mat-label>{{label}}</mat-label>
    <input
      matInput
      formControlName="password"
      placeholder="Password"
      name="password"
      type="password"
      />
    <mat-error *ngIf="formGroup?.controls?.password.hasError('required')">
      {{passwordValidator.errorMessage.required}}
    </mat-error>
    <mat-error *ngIf="formGroup?.controls?.password.hasError('minlength')">
      {{passwordValidator.errorMessage.minLength}}
    </mat-error>
    <mat-error *ngIf="formGroup?.controls?.password.hasError('pattern')">
      {{passwordValidator.errorMessage.pattern}}
    </mat-error>
  </mat-form-field>
  <div class="py-2"></div>
  <mat-form-field class="w-100" appearance="outline">
    <mat-label>{{confirmationLabel}}</mat-label>
    <input
      matInput
      formControlName="passwordConfirmation"
      placeholder="Confirm password"
      name="passwordConfirmation"
      type="password"
      />
    <mat-error
      *ngIf="formGroup?.controls?.passwordConfirmation.hasError('required')">
      Confirmation is required
    </mat-error>
    <mat-error
      *ngIf="formGroup?.controls?.passwordConfirmation.hasError('passwordMismatch')">
      {{passwordValidator.errorMessage.passwordMismatch}}
    </mat-error>
  </mat-form-field>
  <div class="mt-4" *ngIf="showSubmitButton">
    <button type="submit" mat-raised-button color="primary">Submit</button>
  </div>
</form>
